import { useState } from "react";
import CopyCode from "../CopyCode/CopyCode";
import Icon from "../Icon";

const FooterComponent = () => {
	return (
		<div className="flex flex-col gap-y-10 p-6">
			{/* SECTION 1: BASIC FOOTERS */}
			<div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
				<h2 className="text-xl font-bold text-amber-400 mb-6 flex items-center gap-2"><Icon name="link" className="w-5 h-5" /> Basic Footers</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

					{/* Variation 1: Simple Footer */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Simple Footer</label>
						<div className="border-t border-slate-600 pt-4 text-center">
							<p className="text-slate-400 text-sm">&copy; 2026 Your Company. All rights reserved.</p>
						</div>
						<CopyCode number_code={1} code={`<div className="border-t border-slate-600 pt-4 text-center">
  <p className="text-slate-400 text-sm">
    &copy; 2026 Your Company. All rights reserved.
  </p>
</div>`} />
					</div>

					{/* Variation 2: With Links */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">With Links</label>
						<div className="border-t border-slate-600 pt-4">
							<div className="flex justify-center gap-4 mb-3">
								<a href="#" className="text-amber-400 hover:text-amber-300 text-sm">About</a>
								<a href="#" className="text-amber-400 hover:text-amber-300 text-sm">Contact</a>
								<a href="#" className="text-amber-400 hover:text-amber-300 text-sm">Privacy</a>
							</div>
							<p className="text-slate-500 text-xs text-center">&copy; 2026</p>
						</div>
						<CopyCode number_code={2} code={`<div className="flex justify-center gap-4 mb-3">
  <a href="#" className="text-amber-400 hover:text-amber-300 text-sm">About</a>
  <a href="#" className="text-amber-400 hover:text-amber-300 text-sm">Contact</a>
  <a href="#" className="text-amber-400 hover:text-amber-300 text-sm">Privacy</a>
</div>`} />
					</div>

					{/* Variation 3: Social Icons */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">With Social Icons</label>
						<div className="border-t border-slate-600 pt-4 text-center">
							<div className="flex justify-center gap-4 mb-3">
								<a href="#" className="text-amber-400 hover:text-amber-300 text-lg"><Icon name="github" className="w-5 h-5" /></a>
								<a href="#" className="text-amber-400 hover:text-amber-300 text-lg"><Icon name="brandX" className="w-5 h-5" /></a>
								<a href="#" className="text-amber-400 hover:text-amber-300 text-lg"><Icon name="briefcase" className="w-5 h-5" /></a>
							</div>
							<p className="text-slate-500 text-xs">&copy; 2026 Company</p>
						</div>
						<CopyCode number_code={3} code={`<div className="flex justify-center gap-4 mb-3">
	<a href="#" className="text-amber-400 text-lg">GitHub</a>
	<a href="#" className="text-amber-400 text-lg">X</a>
	<a href="#" className="text-amber-400 text-lg">Work</a>
</div>`} />
					</div>

					{/* Variation 4: Multi-line Footer */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Multi-Line</label>
						<div className="border-t border-slate-600 pt-4 space-y-3">
							<div className="flex justify-between text-sm text-slate-400">
								<a href="#" className="hover:text-amber-400">Privacy Policy</a>
								<a href="#" className="hover:text-amber-400">Terms</a>
								<a href="#" className="hover:text-amber-400">Contact</a>
							</div>
							<p className="text-xs text-slate-500 text-center">&copy; 2026 All rights reserved</p>
						</div>
						<CopyCode number_code={4} code={`<div className="border-t border-slate-600 pt-4 space-y-3">
  <div className="flex justify-between text-sm text-slate-400">
    <a href="#">Privacy</a>
    <a href="#">Terms</a>
    <a href="#">Contact</a>
  </div>
  <p className="text-xs text-center">&copy; 2026</p>
</div>`} />
					</div>

					{/* Variation 5: Minimal Footer */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Minimal Footer</label>
						<div className="py-3 px-4 text-center">
							<small className="text-slate-500 inline-flex items-center gap-1">Built with <Icon name="heart" className="w-4 h-4" /> | 2026</small>
						</div>
						<CopyCode number_code={5} code={`<div className="py-3 px-4 text-center">
	<small className="text-slate-500">Built with care | 2026</small>
</div>`} />
					</div>

					{/* Variation 6: Dark Footer */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Dark Background</label>
						<div className="bg-slate-950 rounded-lg p-4 text-center space-y-2">
							<p className="text-slate-300 font-semibold">Company Name</p>
							<div className="flex justify-center gap-4">
								<a href="#" className="text-slate-400 hover:text-amber-400 text-xs">Home</a>
								<a href="#" className="text-slate-400 hover:text-amber-400 text-xs">Blog</a>
								<a href="#" className="text-slate-400 hover:text-amber-400 text-xs">Help</a>
							</div>
							<p className="text-slate-600 text-xs">&copy; 2026</p>
						</div>
						<CopyCode number_code={6} code={`<div className="bg-slate-950 rounded-lg p-4 text-center space-y-2">
  <p className="text-slate-300 font-semibold">Company Name</p>
  <div className="flex justify-center gap-4">
    <a href="#" className="text-slate-400 hover:text-amber-400">Link</a>
  </div>
</div>`} />
					</div>

				</div>
			</div>

			{/* SECTION 2: ADVANCED FOOTERS */}
			<div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
				<h2 className="text-xl font-bold text-amber-400 mb-6 flex items-center gap-2"><Icon name="sparkles" className="w-5 h-5" /> Advanced Footers</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

					{/* Variation 7: Three Column */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Three Column</label>
						<div className="border-t border-slate-600 pt-4">
							<div className="grid grid-cols-3 gap-4 text-center mb-3 text-xs">
								<div>
									<p className="text-slate-300 font-semibold mb-1">Product</p>
									<a href="#" className="text-slate-400 hover:text-amber-400 block">Features</a>
								</div>
								<div>
									<p className="text-slate-300 font-semibold mb-1">Company</p>
									<a href="#" className="text-slate-400 hover:text-amber-400 block">About</a>
								</div>
								<div>
									<p className="text-slate-300 font-semibold mb-1">Legal</p>
									<a href="#" className="text-slate-400 hover:text-amber-400 block">Terms</a>
								</div>
							</div>
							<p className="text-slate-500 text-xs text-center">&copy; 2026</p>
						</div>
						<CopyCode number_code={7} code={`<div className="grid grid-cols-3 gap-4 text-center mb-3 text-xs">
  <div>
    <p className="text-slate-300 font-semibold">Product</p>
    <a href="#">Features</a>
  </div>
  <!-- More columns -->
</div>`} />
					</div>

					{/* Variation 8: With Newsletter */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">With Newsletter</label>
						<div className="border-t border-slate-600 pt-4 space-y-3">
							<div className="text-center">
								<p className="text-slate-300 text-xs mb-2 font-semibold">Subscribe to updates</p>
								<div className="flex gap-1">
									<input type="email" placeholder="Your email" className="flex-1 px-2 py-1 bg-slate-700 border border-slate-600 rounded text-xs text-slate-300 placeholder-slate-500" />
									<button className="px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white text-xs rounded">Join</button>
								</div>
							</div>
							<p className="text-slate-500 text-xs text-center">&copy; 2026</p>
						</div>
						<CopyCode number_code={8} code={`<div className="text-center">
  <p className="text-slate-300 text-xs mb-2">Subscribe to updates</p>
  <div className="flex gap-1">
    <input type="email" placeholder="Your email" />
    <button className="px-3 py-1 bg-amber-600">Join</button>
  </div>
</div>`} />
					</div>

					{/* Variation 9: Gradient Footer */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Gradient Style</label>
						<div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-lg p-4">
							<div className="flex justify-between items-center">
								<p className="text-slate-300 font-semibold text-sm">Your Brand</p>
								<div className="flex gap-3">
									<a href="#" className="text-slate-400 hover:text-amber-400"><Icon name="github" className="w-4 h-4" /></a>
									<a href="#" className="text-slate-400 hover:text-amber-400"><Icon name="brandX" className="w-4 h-4" /></a>
								</div>
							</div>
							<p className="text-slate-500 text-xs mt-2 border-t border-slate-700 pt-2">&copy; 2026</p>
						</div>
						<CopyCode number_code={9} code={`<div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-lg p-4">
  <div className="flex justify-between items-center">
    <p className="text-slate-300 font-semibold">Your Brand</p>
    <div className="flex gap-3">
	<a href="#">GitHub</a>
	<a href="#">X</a>
    </div>
  </div>
</div>`} />
					</div>

					{/* Variation 10: Footer with Divider */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">With Divider</label>
						<div className="pt-4">
							<div className="border-t-2 border-amber-500/30 pt-4 text-center space-y-2">
								<p className="text-slate-300 text-sm inline-flex items-center gap-1">Made with passion <Icon name="rocket" className="w-4 h-4" /></p>
								<p className="text-slate-500 text-xs">Contact: hello@company.com</p>
								<p className="text-slate-600 text-xs">&copy; 2026 Company</p>
							</div>
						</div>
						<CopyCode number_code={10} code={`<div className="border-t-2 border-amber-500/30 pt-4 text-center space-y-2">
	<p className="text-slate-300">Made with passion</p>
  <p className="text-slate-500 text-xs">Contact: hello@company.com</p>
</div>`} />
					</div>

					{/* Variation 11: Compact Footer */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Compact Footer</label>
						<div className="flex justify-between items-center text-xs text-slate-400 py-2 px-3 border-t border-slate-600">
							<span>&copy; 2026</span>
							<div className="flex gap-3">
								<a href="#" className="hover:text-amber-400">Docs</a>
								<a href="#" className="hover:text-amber-400">Help</a>
								<a href="#" className="hover:text-amber-400">Status</a>
							</div>
						</div>
						<CopyCode number_code={11} code={`<div className="flex justify-between items-center text-xs text-slate-400 py-2 px-3 border-t border-slate-600">
  <span>&copy; 2026</span>
  <div className="flex gap-3">
    <a href="#">Docs</a>
    <a href="#">Help</a>
  </div>
</div>`} />
					</div>

					{/* Variation 12: Full Width Footer */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Full Width Layout</label>
						<div className="space-y-3 -m-3 bg-gradient-to-r from-slate-800 via-slate-850 to-slate-900 p-4">
							<div className="grid grid-cols-2 gap-4 text-xs">
								<div>
									<p className="text-slate-300 font-semibold mb-2">Resources</p>
									<ul className="space-y-1 text-slate-400">
										<li><a href="#" className="hover:text-amber-400">Documentation</a></li>
										<li><a href="#" className="hover:text-amber-400">API Reference</a></li>
									</ul>
								</div>
								<div>
									<p className="text-slate-300 font-semibold mb-2">Legal</p>
									<ul className="space-y-1 text-slate-400">
										<li><a href="#" className="hover:text-amber-400">Privacy</a></li>
										<li><a href="#" className="hover:text-amber-400">Terms</a></li>
									</ul>
								</div>
							</div>
							<div className="border-t border-slate-700 pt-3 text-center">
								<p className="text-slate-500 text-xs">&copy; 2026 Company. All rights reserved.</p>
							</div>
						</div>
						<CopyCode number_code={12} code={`<div className="space-y-3 bg-gradient-to-r p-4">
  <div className="grid grid-cols-2 gap-4 text-xs">
    <!-- Columns -->
  </div>
  <div className="border-t border-slate-700 pt-3 text-center">
    <p>&copy; 2026</p>
  </div>
</div>`} />
					</div>

				</div>
			</div>
		</div>
	);
};

export default FooterComponent;


